import { ModalHeader, FloraTypography, ModalBody, Flex, FloraButton } from '@grupoboticario/flora-react'

import ActionModal from '@/components/Modal/ActionModal'

import * as S from './ModalPublishConfirmation.styles'

export const ModalPublishConfirmation = ({
  openPublishConfirmationModal,
  setOpenPublishConfirmationModal,
  handleSubmit,
  isLoading
}) => {
  return (
    <ActionModal
      css={S.modalWrapperCss}
      onOpenChange={setOpenPublishConfirmationModal}
      open={Boolean(openPublishConfirmationModal)}
      size="small"
    >
      <ModalHeader>
        <FloraTypography fontSize="title">Acelerador de pontos</FloraTypography>
      </ModalHeader>
      <ModalBody>
        <Flex direction="column" gap="$6">
          <FloraTypography fontSize="bodyLargeStandard" css={S.centeredTextCss}>
            Ao continuar, você receberá o número de audiência para concluir a publicação do acelerador na CDP.
          </FloraTypography>
          <Flex gap="$3">
            <FloraButton
              disabled={isLoading}
              isFull
              onClick={() => setOpenPublishConfirmationModal(false)}
              hierarchy="secondary"
            >
              Voltar
            </FloraButton>
            <FloraButton disabled={isLoading} isFull isLoading={isLoading} onClick={handleSubmit}>
              Publicar
            </FloraButton>
          </Flex>
        </Flex>
      </ModalBody>
    </ActionModal>
  )
}
